import "./index.scss";
import {
  BrandRestrictionsHeader,
  BrandRestrictionsList
} from "components/UI/molecules";
import { useGetRestrictedBrands } from "./utils/useGetRestrictedBrands";
import { ReactHelmetWithProvider } from "providers/ReactHelmetProvider";
import { INTERNAL_PATHS } from "routes/paths";

export const BrandRestrictions = () => {
  const { isLoading, restrictedBrands } = useGetRestrictedBrands();

  return (
    <div className="brand-restrictions">
      <ReactHelmetWithProvider>
        <meta
          name="description"
          content="GCX is a gift card marketplace where users can sell or buy gift cards online at a discount."
        />
        <title>Raise: Buy and Sell Gift Cards - Exchange Gift Cards</title>
        <link
          rel="canonical"
          href={process.env.REACT_APP_URL + INTERNAL_PATHS.BRAND_RESTRICTIONS}
        />
      </ReactHelmetWithProvider>
      <BrandRestrictionsHeader
        isLoading={isLoading}
        lastUpdate={restrictedBrands?.last_update}
      />
      {!isLoading && restrictedBrands && (
        <div className="brand-restrictions-table">
          <BrandRestrictionsList
            title="Brands Not Accepted"
            list={restrictedBrands.not_accepted_brands}
          />
          <BrandRestrictionsList
            title="Brands with Restrictions"
            list={restrictedBrands.brands_with_restrictions}
          />
        </div>
      )}
    </div>
  );
};
